import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Link,
    Button,
    Divider,
} from "@mui/material";
import SocialButtons from "./SocialButtons";
import useLogin from "../../../hooks/useLogin";
import { useAuth } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertContext";
import { colors } from "../../../styles/Variables";

const LoginForm = ({ setIsLogin, onSuccess, handleClose, onForgotPassword   }) => {
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const { login, loading } = useLogin();
    const { auth } = useAuth();
    const { showAlert } = useAlert();
    const handleLogin = async (e) => {
        e.preventDefault();
        const { token, error } = await login(email.trim(), senha);
        if (!token) {
            showAlert(error || "Erro no login, verifique suas credenciais!", "error");
            return;
        }
        await auth();
        showAlert("Login realizado com sucesso!", "success");
        if (handleClose) handleClose();
        if (onSuccess) onSuccess();
    };
    return (
        <Box
        component="form"
        onSubmit={handleLogin}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
        
        <Typography
            variant="caption"
            sx={{
            fontWeight: "bold",
            color: "#999",
            letterSpacing: 1,
            fontSize: 12,
            }}
        >
            
            E M A I L
        </Typography>
        <TextField
            placeholder="E-mail"
            name="email"
            type="email"
            required
            autoComplete="email"
            inputProps={{ "aria-label": "E-mail" }}
            variant="outlined"
            size="small"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
        />
        <Typography
            variant="caption"
            sx={{
            fontWeight: "bold",
            color: "#999",
            letterSpacing: 1,
            fontSize: 12,
            }}
        >
            
            S E N H A
        </Typography>
        <TextField
            placeholder="Senha"
            name="password"
            required
            autoComplete="current-password"
            inputProps={{ "aria-label": "Senha" }}
            variant="outlined"
            size="small"
            type="password"
            fullWidth
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
        />
        <Button
            onClick={onForgotPassword}
                sx={{ 
                    color: colors.goldColor,
                    fontSize: 12, 
                    alignSelf: "flex-start", 
                    mt: -1, 
                    textDecoration: 'underline',
                    "&:hover": {
                        textDecoration: 'underline',
                    }
                }}
            >
            Esqueci minha senha
        </Button>
        <Button
            className="btn-primary-2"
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
            mt: 3,
            backgroundColor: colors.blueColor,
            fontWeight: "bold",
            textTransform: "uppercase",
            borderRadius: 1,
            py: 1.5,
            }}
        >
            {loading ? "ENTRANDO..." : "ACESSAR CONTA"}
        </Button>
        <Divider sx={{ my: 3, color: "#999" }}>Ou entre usando</Divider>
        <SocialButtons />
        <Typography
            sx={{ mt: 3, fontSize: 13, color: colors.goldColor, textAlign: "center" }}
        >
            Ainda não possui uma conta?
            <Link
            href="#"
            onClick={(e) => {
                e.preventDefault();
                setIsLogin(false);
            }}
            sx={{ color: colors.goldColor }}
            >
            
            Crie agora.
            </Link>
        </Typography>
        </Box>
    );
};
export default LoginForm;
